import * as React from 'react';
import ReactImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { ImageBoxData } from '../../services/types';
import CapIcon from './assets/CapIcon.svg';
import TimeIcon from './assets/TimeIcon.svg';
import './index.scss';
import LanguageContext, { LangContext } from '../LanguageContext';

export type ImageBoxProps = ImageBoxData & {
  showExtraText: boolean;
};

export interface ImageBoxState {
  expandText: boolean;
}

export default class ImageBox extends React.Component<ImageBoxProps, ImageBoxState> {
  public static defaultProps: Partial<ImageBoxProps> = {
    images: [],
  };
  public state: ImageBoxState = {
    expandText: false,
  };

  get image() {
    const { images } = this.props;

    const galleryImages: ReactImageGalleryItem[] = images.map((entry) => ({
      original: `${entry}`,
      thumbnail: `${entry}`,
    }));

    return (
      <ReactImageGallery
        items={galleryImages}
        showFullscreenButton={true}
        showNav={true}
        showPlayButton={false}
        showThumbnails={false}
      />
    );
  }

  public render() {
    const { props } = this;

    return (
      <LangContext.Consumer>
        {(ctx) => (
          <div className="ImageBox">
            {this.image}
            <div className="content">
              <h1>{props.name}</h1>
              {this.getText(ctx.lang)}
              <div className="info">
                {!isNaN(props.startYear) && !isNaN(props.endYear) && (
                  <span>
                    <img src={TimeIcon} />
                    {this.getYears(ctx.lang)}
                  </span>
                )}
                {this.getCoord(ctx.lang) !== '' && (
                  <span>
                    <img src={CapIcon} />
                    {this.getCoord(ctx.lang)}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
      </LangContext.Consumer>
    );
  }

  private getText(lang: 'en' | 'ro') {
    const { expandText } = this.state;
    const { showExtraText, extraDescription, extraDescriptionRo, description, descriptionRo } = this.props;
    let textElement: JSX.Element | JSX.Element[] | null = null;
    let text = '';

    if (lang === 'en') {
      text = description;
    } else if (lang === 'ro') {
      text = descriptionRo;
    }

    if (text.length === 0) {
      return '';
    }

    if (text.length < 150) {
      textElement = <p>{text}</p>;
    }

    if (!expandText) {
      text = text.slice(0, 150);
      text = text.slice(0, text.lastIndexOf(' ')) + '...';
      textElement = (
        <p>
          {text}.<span onClick={this.toggleExpand}>⏬</span>
        </p>
      );
    } else {
      textElement = text.split('.').map((sentence, key, { length }) => (
        <p key={key}>
          {sentence}.{key === length - 1 && <span onClick={this.toggleExpand}>⏫</span>}
        </p>
      ));
    }

    return textElement;
  }

  private getCoord(lang: 'ro' | 'en'): string {
    if (lang === 'en') {
      return this.props.coord;
    } else {
      return this.props.coordRo;
    }
  }

  private getYears(lang: 'ro' | 'en'): string {
    const { startYear, endYear } = this.props;
    let result: string = startYear.toString();

    if (startYear !== endYear) {
      result += ' - ';

      if (endYear === 2019) {
        result += `${lang === 'en' ? 'Present' : 'Prezent'}`;
      } else {
        result += endYear.toString();
      }
    } else {
      if (startYear === 2019) {
        return lang === 'en' ? 'Present' : 'Prezent';
      }
    }

    return result;
  }

  private toggleExpand = () => this.setState({ expandText: !this.state.expandText });
}
